import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
export const PageTitle = ({ title, dataTestId, }) => {
    return (React.createElement("div", null,
        React.createElement(Typography, { weight: "display", variant: "h1", uppercase: true, "data-testid": dataTestId }, title)));
};
